var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPessoasMontandoLego(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_2",
    "data-name": "Camada 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 649.19 732.68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: rgba(255, 255, 255, .7);\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5 {\n        isolation: isolate;\n      }\n\n      .cls-1, .cls-3 {\n        opacity: .3;\n      }\n\n      .cls-6, .cls-2, .cls-7, .cls-8, .cls-9 {\n        fill: #88bd28;\n      }\n\n      .cls-6, .cls-10, .cls-7, .cls-11, .cls-12, .cls-8, .cls-13, .cls-14, .cls-15, .cls-16, .cls-17 {\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n\n      .cls-6, .cls-10, .cls-7, .cls-11, .cls-8, .cls-13, .cls-14, .cls-15, .cls-18, .cls-16, .cls-17 {\n        stroke: #263238;\n      }\n\n      .cls-19 {\n        clip-path: url(#clippath-11);\n      }\n\n      .cls-20, .cls-14, .cls-4 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        opacity: .4;\n      }\n\n      .cls-10 {\n        fill: #757575;\n      }\n\n      .cls-21 {\n        fill: #bfbfbf;\n      }\n\n      .cls-7, .cls-15 {\n        stroke-width: 1px;\n      }\n\n      .cls-11 {\n        stroke-width: 1px;\n      }\n\n      .cls-11, .cls-12, .cls-15, .cls-18, .cls-22, .cls-16, .cls-17 {\n        fill: none;\n      }\n\n      .cls-23 {\n        clip-path: url(#clippath-2);\n      }\n\n      .cls-24 {\n        clip-path: url(#clippath-6);\n      }\n\n      .cls-12 {\n        stroke: #fff;\n      }\n\n      .cls-25 {\n        clip-path: url(#clippath-7);\n      }\n\n      .cls-8, .cls-17 {\n        stroke-width: 1px;\n      }\n\n      .cls-26 {\n        clip-path: url(#clippath-1);\n      }\n\n      .cls-27 {\n        clip-path: url(#clippath-4);\n      }\n\n      .cls-13, .cls-28 {\n        fill: #999;\n      }\n\n      .cls-29 {\n        clip-path: url(#clippath-12);\n      }\n\n      .cls-30 {\n        clip-path: url(#clippath-9);\n      }\n\n      .cls-18 {\n        stroke-miterlimit: 10;\n      }\n\n      .cls-31 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-4 {\n        opacity: .7;\n      }\n\n      .cls-32 {\n        clip-path: url(#clippath-3);\n      }\n\n      .cls-33 {\n        clip-path: url(#clippath-8);\n      }\n\n      .cls-5 {\n        opacity: .2;\n      }\n\n      .cls-34 {\n        clip-path: url(#clippath-5);\n      }\n\n      .cls-35 {\n        clip-path: url(#clippath-10);\n      }\n\n      .cls-36 {\n        fill: #263238;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "m500.71,605.37s-21.5-7.92-25.7,7.92c0,0,3.84,17.45,1.54,26.99s-13.88,27.77-14.59,31.23c-1.41,6.78-.35,7.24-.35,7.24,0,0,8.42,4.86,19.73-.35,11.31-5.21,30.9-27.64,33.96-32.25,3.06-4.61-9.59-22.81-9.59-22.81l-4.99-17.98Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "m304.04,324.88l36.39,3.27c1.72.15,2.98,1.67,2.83,3.39h0s-2.34,25.97-2.34,25.97h0l-42.61-3.83h0l2.34-25.97c.15-1.72,1.67-2.98,3.39-2.83h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "m366.85,327.17l36.25,3.11c1.71.15,2.98,1.65,2.83,3.36h0s-2.22,25.87-2.22,25.87h0l-42.45-3.65h0l2.22-25.87c.15-1.71,1.65-2.98,3.36-2.83h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "m472.11,359.36l-10.24,118.97-191.68-16.54,10.24-118.95c.35-4.13,3.98-7.2,8.12-6.85,0,0,.01,0,.02,0l176.68,15.18c4.13.34,7.21,3.96,6.87,8.1,0,.03,0,.06,0,.09Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "m557.47,628s-9.16-6.53-28.12-5.23c0,0-1.39,22.74-3.97,29.36-2.58,6.62-16.18,18.08-18.71,20.05-2.53,1.97-2.53,8.83-2.53,8.83h57.59c-.74-9.84-2.27-19.61-4.58-29.21l.31-23.8Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "m572.16,395.48s-36.73,7.19-72.77-4.48c-8.21-2.61-16.06-6.24-23.37-10.78,0,0,.1-2.32.17-6.1.3-14.79.22-51.98-7.58-61.2-4.96-5.81-8.85-41.7.73-59.84l29.29-23.55c40.55,7.92,49.12,18.66,55.82,41.81,1.24,4.23,2.4,8.88,3.69,14.01,1.41,5.59,2.73,12.42,3.99,19.85,6.09,36.98,10.04,90.29,10.04,90.29Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "m210.65,361.88l6.62,14.03s27.36,56.53,44.11,121.27c.4,1.54,9.06,32.2,2.12,108.57l3.97,13.4-4.33,22.13s6.52,9.41,6.29,12.49c0,0-16.08,2.99-21.5,5.87-4.17,2.25-16.69,14.6-16.69,14.6-3.56-.73-3.87-15.08-3.87-15.08,0,0-7.43-127.47-9.56-132.96-2.13-5.49-15.17-29.18-35.51-83.38,0,0-.46,75.7-5.89,94.85-4.85,17.04.89,64.72.89,64.72l-3.31,53.08s11.45,11.89,2.17,15.08c0,0-6.2-11.93-23.87-14.64-8.98-1.39-20.16,14.55-20.16,14.55-3.94-1.26,1.65-21.29,1.65-21.29-12.52-94.47-3.31-77.37-5.79-123.55-1.65-29.64-10.01-156.43-.15-166.74l82.81,2.99Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "m234.01,125.61l36.23-3.34c1.71-.16,3.22,1.1,3.38,2.81h0l2.39,25.86h0l-42.36,3.91h0l-2.39-25.86c-.16-1.68,1.06-3.18,2.74-3.38Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "m296.66,119.79l36.23-3.34c1.71-.16,3.22,1.1,3.38,2.81h0l2.39,25.86h0l-42.43,3.91h0l-2.39-25.86c-.16-1.71,1.1-3.22,2.81-3.38h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "m405.98,132.82l10.98,118.89-191.61,17.7-10.92-118.92c-.38-4.14,2.66-7.8,6.8-8.19l176.58-16.29c4.13-.38,7.79,2.66,8.17,6.79,0,0,0,.02,0,.03Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "m268.9,542.82h36.39c1.72,0,3.11,1.39,3.11,3.11h0v25.97h-42.61v-25.97c0-1.72,1.39-3.11,3.11-3.11h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "m331.75,542.82h36.39c1.72,0,3.11,1.39,3.11,3.11h0v25.97h-42.61v-25.97c0-1.72,1.39-3.11,3.11-3.11h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "m439.41,565.84v119.4h-192.37v-119.4c0-4.16,3.37-7.53,7.53-7.53h177.32c4.16,0,7.53,3.37,7.53,7.53h0Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_1-2",
    "data-name": "Camada 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-456"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m23.46,228.2s-46.11,119.08,18.69,239c64.8,119.91,198.28,183.26,305.11,237.43,106.83,54.17,217.76,27.79,270.47-60.93,52.71-88.72-19.58-152.05-19.68-278.56-.1-126.51,18.94-160-49.62-266.88C479.87-8.63,311.81-32.29,184.72,46.98,57.63,126.25,23.46,228.2,23.46,228.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m93.04,137.86c22.26-26.6,52.35-47.09,88.21-46.74,61.2.76,94.28,54.93,129.37,96.71,18.19,21.67,38.85,42.57,65.88,52.76,40.54,15.27,85.69,6.35,125.19-7.82,17.7-6.35,38.65-15.28,58.58-10.72,60.58,13.86,54.28,87.79,44.28,134.62-13.51,63.25-35.48,130.5-79.99,179.02-106.56,116.26-298.34,44.99-394.47-47.78-7.06-6.83-13.83-13.94-20.19-21.5-16.54-19.29-30.54-40.61-41.66-63.46-30.96-64.42-35.23-142.72-8.27-209.29,8.1-20.18,19.25-39,33.08-55.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m93.04,137.86c22.26-26.6,52.35-47.09,88.21-46.74,61.2.76,94.28,54.93,129.37,96.71,18.19,21.67,38.85,42.57,65.88,52.76,40.54,15.27,85.69,6.35,125.19-7.82,17.7-6.35,38.65-15.28,58.58-10.72,60.58,13.86,54.28,87.79,44.28,134.62-13.51,63.25-35.48,130.5-79.99,179.02-106.56,116.26-298.34,44.99-394.47-47.78-7.06-6.83-13.83-13.94-20.19-21.5-16.54-19.29-30.54-40.61-41.66-63.46-30.96-64.42-35.23-142.72-8.27-209.29,8.1-20.18,19.25-39,33.08-55.79Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-456"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-16",
    x1: 0.5,
    y1: 685.26,
    x2: 648.69,
    y2: 685.26
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Window--inject-456"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-16",
    points: "394.01 350.12 394.01 106.75 409.08 106.75"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-16",
    x1: 394.01,
    y1: 379.08,
    x2: 394.01,
    y2: 372.63
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-16",
    points: "447.83 106.75 603.32 106.75 603.32 401.77 394.01 401.77"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-16",
    x1: 428.78,
    y1: 106.75,
    x2: 442.44,
    y2: 106.75
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 401.88,
    y: 114.61,
    width: 193.56,
    height: 279.3
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-16",
    points: "586.45 129.56 586.45 245.55 410.88 245.55 410.88 237.98"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-16",
    points: "410.88 220.25 410.88 122.85 586.45 122.85"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-16",
    x1: 410.88,
    y1: 232.17,
    x2: 410.88,
    y2: 224.81
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-16",
    x1: 556.79,
    y1: 254.25,
    x2: 595.44,
    y2: 254.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-16",
    x1: 543.05,
    y1: 254.25,
    x2: 548.52,
    y2: 254.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-16",
    x1: 401.88,
    y1: 254.25,
    x2: 536.53,
    y2: 254.25
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-16",
    points: "488.93 245.55 488.93 241.55 505.12 241.55 505.12 243.82 498.67 243.82 498.67 245.55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m402.21,358.72s2.7,2.03,4.58,14.34c0,0,3.31-19.65,7.18-19.95s3.14,12.77,3.14,12.77c0,0,.66-6.43,3.74-6.14s0,13.23,0,13.23c0,0,3.7-10.16,7.21-9.92,3.51.23-2.32,18.39-2.32,18.39,0,0,9-6.52,12.64-3.31,3.64,3.21-2.02,11.21-2.02,11.21,0,0,12.9-2.8,14.89,4.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m451.27,386.83s5.62-3.69,10.06-1.97c0,0-2.81-4.28,0-6.9,2.81-2.61,6.42,6.9,6.42,6.9,0,0,.41-15.96,6.04-15.15s0,15.15,0,15.15c0,0,10.04-8.9,12.45-5.81s-1.65,7.77-1.65,7.77c3.69-1.05,7.66-.07,10.45,2.56,0,0,6.73-6.86,14.21-7.86,0,0-4.96-14.44-2.56-17.35,2.4-2.91,6.8,12.6,6.8,12.6,0,0,1.92-10.09,8.27-10.88,0,0-5.24-2.84-3.69-7.16,1.55-4.32,8.78,1.03,8.78,1.03,0,0-2.98-7.59,1.74-9.68,4.71-2.08,6.62,6.35,6.62,6.35,0,0,1.32-8.83,6.85-8.27s3.74,10.65,3.74,10.65c0,0,5.21-8.07,8.01-7.26,5.57,1.65,3.89,14.42,3.89,14.42,0,0,7.77-5.41,9.79-2.91,2.02,2.5-8.1,9.61-8.1,9.61,0,0,7.72.84,12.54,5.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m595.44,361.69s-.89-8.1-9-8.53c-8.1-.43,2.23,17.78,2.23,17.78,0,0-6.7-5.54-9.1-3.84-2.4,1.7,6.86,11.1,6.86,11.1,0,0-4.45-4.12-9.13-2.84-4.68,1.27,2.66,14.32,2.66,14.32-6.93-1.39-14.11-.54-20.53,2.41"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Table--inject-456"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-16",
    x1: 319.12,
    y1: 612.85,
    x2: 319.12,
    y2: 684.83
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-16",
    x1: 319.12,
    y1: 589.29,
    x2: 319.12,
    y2: 604.71
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-16",
    points: "16.11 685.26 16.11 551.12 319.12 551.12 319.12 580.56"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-16",
    points: "60.26 565.79 33.96 565.79 33.96 672.95"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-16",
    points: "301.27 684.83 301.27 565.79 75.52 565.79"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-16",
    x1: 288.67,
    y1: 537.23,
    x2: 280.32,
    y2: 537.23
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-16",
    points: "268.32 537.23 8.59 537.23 8.59 551.02 326.64 551.02 326.64 537.23 293.99 537.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m26.5,448.84s24.81,1.97,25.93,20.33c0,0-25.22,11.61-25.93-20.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m75.74,453.41s13.91-18.81,36.39-9.16c0,0-13.73,22.73-36.39,9.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m110.22,394.03s4,36.17-28.93,26.22c0,0,10.45-26.6,28.93-26.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m69.78,373.88s26.05,14.06,6.9,35.36c0,0-18.26-15.22-6.9-35.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m37.75,406.22s28.32-2.84,28.32,23.35c0,0-28.32,1.12-28.32-23.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m58.97,483.97c-.41-8.8-.41-20.11,4.96-32.07,12.39-27.59,16.54-50.83,10.11-67.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m47.04,413.3s16.97,6.75,22.74,24.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m101.31,408.5s-9.81,13.36-26.46,11.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m101.31,448.03s-27.17,7.82-38.04,5.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m34.6,457.11s12.16,13.33,24.36,13.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m91.27,483.97h-59.03c-.79,0-1.44.64-1.44,1.44v4.48c0,.79.64,1.42,1.42,1.42,0,0,.01,0,.02,0h1.65l5.26,45.91h45.12l5.26-45.91h1.74c.78,0,1.41-.61,1.42-1.39,0-.01,0-.02,0-.03v-4.48c0-.79-.62-1.43-1.41-1.44,0,0-.01,0-.02,0Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-16",
    x1: 37.75,
    y1: 491.31,
    x2: 72.08,
    y2: 491.31
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-16",
    x1: 78.55,
    y1: 491.31,
    x2: 83.71,
    y2: 491.31
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-3--inject-456"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m454.78,300.98l-6.62,35.96-53.95,32.78,7.46,13.69s62.37-19.02,63.89-23.47c1.52-4.45,15.89-51.57,15.89-51.57l-26.68-7.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m478.41,240.18l-3.61,43.6-1.9,22.87c-10.4,5.06-20.58-2.55-21.2-3.04h0c2.83-8.3,6.12-55.16,26.71-63.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m474.74,283.78l-1.9,22.87c-10.4,5.06-20.58-2.55-21.2-3.04.45.2,5.92,2.51,9.48,0-1.24-1.34-2.35-2.81-3.31-4.37-.22-.86,3.31-1.09,3.31-1.09,0,0-2.32-18.54,3.85-26.46,2.41-3.01,6.19,3.27,9.77,12.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m515.77,643.93l1.65,4.86c-2.51,4.14-5.31,8.08-8.4,11.81,0,0-1.65-.53-4.37,1.87-1.67,1.67-2.7,3.87-2.91,6.22,0,0-12.64,15.15-28.66,15.37-16.03.22-11.2-7.86-11.2-7.86l53.89-32.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m500.71,605.37s-21.5-7.92-25.7,7.92c0,0,3.84,17.45,1.54,26.99s-13.88,27.77-14.59,31.23c-1.41,6.78-.35,7.24-.35,7.24,0,0,8.42,4.86,19.73-.35,11.31-5.21,30.9-27.64,33.96-32.25,3.06-4.61-9.59-22.81-9.59-22.81l-4.99-17.98Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-31"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m500.71,605.37s-21.5-7.92-25.7,7.92c0,0,3.84,17.45,1.54,26.99s-13.88,27.77-14.59,31.23c-1.41,6.78-.35,7.24-.35,7.24,0,0,8.42,4.86,19.73-.35,11.31-5.21,30.9-27.64,33.96-32.25,3.06-4.61-9.59-22.81-9.59-22.81l-4.99-17.98Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m500.71,605.37s-21.5-7.92-25.7,7.92c0,0,3.84,17.45,1.54,26.99s-13.88,27.77-14.59,31.23c-1.41,6.78-.35,7.24-.35,7.24,0,0,8.42,4.86,19.73-.35,11.31-5.21,30.9-27.64,33.96-32.25,3.06-4.61-9.59-22.81-9.59-22.81l-4.99-17.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m489.71,627.78c1.87,10.67-.03,21.67-5.38,31.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m484.33,663.04c-1.62,4.08-5,7.21-9.2,8.5-4.33,1.16-8.9,1.16-13.23,0l5.16-10.45c5.48,2.18,11.44,2.86,17.27,1.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m487.37,656.71s-11.25.68-17.12-1.65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m489.46,650.51s-10.52,1.65-16.39-1.65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m491.25,643.61s-9.21,1.34-15.23-1.51"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m492.27,635.8s-10.25,3.21-15.1,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m493.81,616.52l1.79,11.26s-13.56,8.93-22.53-2.23v-11.76s3.37,7.91,20.74,2.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m482.03,363.68c-13.74,43.55-56.4,113.4-52.08,131.27,2.37,9.76,16.44,65.05,27.46,89.31,4.18,9.28,13.23,15.48,13.23,15.48l6.53,14.01c15.93,6.93,21.63-7.16,21.63-7.16l-3.21-15.88c8.53-15.51,4.96-15.51-6.14-95.93-1.31-9.48,20.67-38.77,20.67-38.77l11.28,73.7,1.84,60.37,5.86,18.66s1.46,17.52,1.32,18.57h26.18l2.84-19.25s12.16-11.46,12.16-24.69-2.61-80.63,0-100.26-6.12-111.16-6.12-111.16l-83.46-8.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m304.04,324.88l36.39,3.27c1.72.15,2.98,1.67,2.83,3.39h0s-2.34,25.97-2.34,25.97h0l-42.61-3.83h0l2.34-25.97c.15-1.72,1.67-2.98,3.39-2.83h0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-26"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m304.04,324.88l36.39,3.27c1.72.15,2.98,1.67,2.83,3.39h0s-2.34,25.97-2.34,25.97h0l-42.61-3.83h0l2.34-25.97c.15-1.72,1.67-2.98,3.39-2.83h0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 324.42,
    y: 332.45,
    width: 20.94,
    height: 10.47,
    transform: "translate(-30.22 642.44) rotate(-85.09)"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m304.04,324.88l36.39,3.27c1.72.15,2.98,1.67,2.83,3.39h0s-2.34,25.97-2.34,25.97h0l-42.61-3.83h0l2.34-25.97c.15-1.72,1.67-2.98,3.39-2.83h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m366.85,327.17l36.25,3.11c1.71.15,2.98,1.65,2.83,3.36h0s-2.22,25.87-2.22,25.87h0l-42.45-3.65h0l2.22-25.87c.15-1.71,1.65-2.98,3.36-2.83h0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m366.85,327.17l36.25,3.11c1.71.15,2.98,1.65,2.83,3.36h0s-2.22,25.87-2.22,25.87h0l-42.45-3.65h0l2.22-25.87c.15-1.71,1.65-2.98,3.36-2.83h0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 388.39,
    y: 340.03,
    width: 20.94,
    height: 6.32,
    transform: "translate(22.79 711.21) rotate(-85.09)"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m366.85,327.17l36.25,3.11c1.71.15,2.98,1.65,2.83,3.36h0s-2.22,25.87-2.22,25.87h0l-42.45-3.65h0l2.22-25.87c.15-1.71,1.65-2.98,3.36-2.83h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m353.68,326.03l36.25,3.11c1.71.15,2.98,1.65,2.83,3.36h0s-2.22,25.87-2.22,25.87h0l-42.45-3.65h0l2.22-25.87c.15-1.71,1.65-2.98,3.36-2.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m416.29,331.42l36.25,3.11c1.71.15,2.98,1.65,2.83,3.36h0s-2.22,25.86-2.22,25.86h0l-42.45-3.65h0l2.22-25.87c.16-1.7,1.66-2.96,3.36-2.82Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 373.86,
    y: 336.7,
    width: 20.94,
    height: 10.47,
    transform: "translate(10.76 695.58) rotate(-85.09)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 435.78,
    y: 342.01,
    width: 20.94,
    height: 10.47,
    transform: "translate(62.08 762.13) rotate(-85.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m472.11,359.36l-10.24,118.97-191.68-16.54,10.24-118.95c.35-4.13,3.98-7.2,8.12-6.85,0,0,.01,0,.02,0l176.68,15.18c4.13.34,7.21,3.96,6.87,8.1,0,.03,0,.06,0,.09Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-32"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m472.11,359.36l-10.24,118.97-191.68-16.54,10.24-118.95c.35-4.13,3.98-7.2,8.12-6.85,0,0,.01,0,.02,0l176.68,15.18c4.13.34,7.21,3.96,6.87,8.1,0,.03,0,.06,0,.09Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m472.11,359.36l-10.24,118.97-191.68-16.54,10.24-118.95c.35-4.13,3.98-7.2,8.12-6.85,0,0,.01,0,.02,0l176.68,15.18c4.13.34,7.21,3.96,6.87,8.1,0,.03,0,.06,0,.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m472.11,359.36l-10.24,118.97-142.24-12.24,10.25-118.95c.35-4.13,3.98-7.2,8.12-6.85,0,0,.01,0,.02,0l127.24,10.93c4.13.35,7.2,3.98,6.85,8.12,0,0,0,.01,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m462.12,362.77l-121.58-10.45c-1.69-.15-2.94-1.62-2.83-3.31h0c.15-1.69,1.62-2.94,3.31-2.83l121.58,10.45c1.69.15,2.94,1.62,2.83,3.31h0c-.15,1.69-1.62,2.94-3.31,2.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m557.47,628s-9.16-6.53-28.12-5.23c0,0-1.39,22.74-3.97,29.36-2.58,6.62-16.18,18.08-18.71,20.05-2.53,1.97-2.53,8.83-2.53,8.83h57.59c-.74-9.84-2.27-19.61-4.58-29.21l.31-23.8Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-27"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m557.47,628s-9.16-6.53-28.12-5.23c0,0-1.39,22.74-3.97,29.36-2.58,6.62-16.18,18.08-18.71,20.05-2.53,1.97-2.53,8.83-2.53,8.83h57.59c-.74-9.84-2.27-19.61-4.58-29.21l.31-23.8Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m557.47,628s-9.16-6.53-28.12-5.23c0,0-1.39,22.74-3.97,29.36-2.58,6.62-16.18,18.08-18.71,20.05-2.53,1.97-2.53,8.83-2.53,8.83h57.59c-.74-9.84-2.27-19.61-4.58-29.21l.31-23.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m545.58,630.94s-1.36,20.94-4.61,26.46c-1.74,3.04-3.89,5.82-6.38,8.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m532.99,668.57s-2.89,3.61-6.1,4.09-20.16-.48-20.16-.48l6.91-5.99s14.06-2.37,19.35,2.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m538.98,663.66s-12.27-7.05-21.02-1.65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m541.94,658.88s-8.57-6.7-18.67-3.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m545.58,651.58s-9.23-7.18-18.95-2.61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m546.83,642.47s-11.2-6.02-19.33-1.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m561.72,681.01v4.25h-6.62s-5.67-3.31-11.06,0h-31.06c-3.28-.01-6.52-.74-9.49-2.13l.65-2.12h57.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m553.47,626.66l-1.47,9.28s-17.28-5.61-26.83-1.97v-11.41s17.75-6.22,28.3,4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "m572.16,395.48s-36.73,7.19-72.77-4.48c-8.21-2.61-16.06-6.24-23.37-10.78,0,0,.1-2.32.17-6.1.3-14.79.22-51.98-7.58-61.2-4.96-5.81-8.85-41.7.73-59.84l29.29-23.55c40.55,7.92,49.12,18.66,55.82,41.81,1.24,4.23,2.4,8.88,3.69,14.01,1.41,5.59,2.73,12.42,3.99,19.85,6.09,36.98,10.04,90.29,10.04,90.29Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-34"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m562.12,305.19l-16.54,73.88s-23.9,6.62-46.18,11.93c-8.21-2.61-16.07-6.24-23.39-10.78,0,0,.1-2.32.17-6.1,20.01-10.24,49.22-25.29,48.99-26-.38-1.11,0-39.69,0-39.69,0,0,26.46-6.14,29.28-37.13,1.24,4.23,2.4,8.88,3.69,14.01,1.41,5.61,2.73,12.39,3.99,19.9Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m572.16,395.48s-36.73,7.19-72.77-4.48c-8.21-2.61-16.06-6.24-23.37-10.78,0,0,.1-2.32.17-6.1.3-14.79.22-51.98-7.58-61.2-4.96-5.81-8.85-41.7.73-59.84l29.29-23.55c40.55,7.92,49.12,18.66,55.82,41.81,1.24,4.23,2.4,8.88,3.69,14.01,1.41,5.59,2.73,12.42,3.99,19.85,6.09,36.98,10.04,90.29,10.04,90.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m499.91,198.61s-12.93,18.52,4.27,32.98c0,0-20.87,23.42-27.74,20.19-2.89-1.36,0-9.81,0-9.81l-12.11-22.39,35.58-20.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m495.69,208.21c4.04-17.65,2.1-43.93-22.63-41.6-17.33,1.65-29.69,11.25-24.81,34.5,2.03,9.81,3.7,23.7,12.7,36.24,2.5,3.47,28.63-8.82,27.04-18.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m460.32,197.18c3.54-1.37,7.51-.98,10.72,1.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m447.88,199.34c.66-1.4,2.24-2.1,3.72-1.65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m454.06,203.01s-5.09,9.28-5.11,10.6,6.27,1.77,6.27,1.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m465.01,204.9c0,1.01-.45,1.84-1.08,1.87s-1.16-.79-1.19-1.8c-.03-1.01.45-1.84,1.08-1.85s1.16.81,1.19,1.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m457.82,222.13s9.77-1.84,11.58-5.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m447.81,185.05l7.61-2.22s10.67-4.96,12.93-4.27c2.27.69,6.86,7.76,6.72,11.79,0,0,7.18,6.32,8.09,15.48l2.18-.99s-.12-8.27,4.58-8.05c4.7.22,6.81,5.84,6.5,7.61s-5.46,9.11-5.46,9.11c0,0,11.78-1.75,12.16-24.81.38-23.06-24.89-26.81-37.18-25.87-6.22.6-12.47.83-18.72.69l.69,6.62-4.96,1.31,3.74,4.58-4.1,1.87,5.23,7.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m490.42,436.45s29.94,7.92,38.04,30.22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m504.13,448.44s-16.18,26.94-40.94,40.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m481.39,599.96s9.2-2.07,11.71-5.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m532.59,603.39s9-4.66,17.96,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m561.72,477.95s-15.1,39.12-22.74,42.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m495.6,416.69c.41,4.25,18.19,23.95,32.86,31.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m510.76,400.07c2.14,5.27,2.59,11.08,1.27,16.62-1.43,4.78-1.43,9.87,0,14.65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m478.41,318.72s27.84,36.02,57.76,47.85"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m507.22,260.49s-.1,24.5,17.56,35.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m517.16,296.23c-3.74,3.67.33,49.75.33,49.75,0,0-21.72,8.5-28.51,13.98-6.8,5.47-39,18.04-39,18.04,0,0-4.96,16.9,1.22,17.48,6.19.58,70.24-21.25,84.9-28.91,0,0,9.54-56.23,9.48-70.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m452.53,376.99c-2.98-.56-8.27-2.51-11.05-1.87-2.78.65-7.86,3.7-13.08,4.96-5.23,1.26-3.06,3.31,0,3.92,2.24.37,4.53.37,6.76,0l-4.25,4.15c-2.43,1.32-4.95,2.48-7.53,3.49-1.54,0-6.98,1.47-6.62,3.79.36,2.32,3.49,2.05,6.98,2.18,0,0-5.56,1.11-4.96,4.27.36,2.17,6.62.22,9.81.22,0,0-2.61,2.84-.66,3.72s6.29-1.31,6.29-1.31c0,0-.17,2.35,1.79,2.58,1.95.23,6.86-1.65,10.2-3.67,3.29-2.12,6.44-4.45,9.43-6.98,1.26-1.16,2.71-2.1,4.28-2.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m423.83,397.68c1.54-.08,3.07-.26,4.58-.53,1.31-.33,2.61-.76,2.61-.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m428.61,402.17c2-.28,3.92-.94,5.67-1.95"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m434.23,404.58c1.48-.19,2.89-.71,4.13-1.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m431.44,389.41s-1.19,2.73,0,4.25c1.19,1.52,2.63,1.65,2.84,3.31.22,1.65,3.06,1.65,4.09,2.73,1.03,1.08,1.8,3.14,5.08,3.31"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m515.77,248.45c-11.26,25.49,0,60.85,0,60.85,0,0,27.26,9.26,29.77,5.28,2.51-3.99,7.11-23.54,7.89-32.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m545.58,284.83s-11.58,15.93-20.79,16.14"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-456"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m131.76,685.26s-2.83-10.8.48-14.8c5.92-7.18-.73-13.23,5.23-15.7l2.5,2.89c.48-2.93-.91-11.88,10.14-13.03,13.36-1.41,13.61,8.27,14.34,11.58l-.23-4.48c5.71,0,2.75,5.69,11.38,14.98,4.58,5.07,6.84,11.82,6.25,18.62l-50.08-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m233.62,685.26c-5.38-2.4-.45-22.68-.45-22.68,0,0-7.23-4.85,0-9.92,5.7,4.83,13.6,6.1,20.53,3.31,0,0,1.41-13.56,9.92-11.83,0,0,2.18,8.6,7.16,13.51,13.48,13.23,30.9,14.89,33.81,21.24.88,1.92-.18,6.3-.18,6.3l-70.79.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "m210.65,361.88l6.62,14.03s27.36,56.53,44.11,121.27c.4,1.54,9.06,32.2,2.12,108.57l3.97,13.4-4.33,22.13s6.52,9.41,6.29,12.49c0,0-16.08,2.99-21.5,5.87-4.17,2.25-16.69,14.6-16.69,14.6-3.56-.73-3.87-15.08-3.87-15.08,0,0-7.43-127.47-9.56-132.96-2.13-5.49-15.17-29.18-35.51-83.38,0,0-.46,75.7-5.89,94.85-4.85,17.04.89,64.72.89,64.72l-3.31,53.08s11.45,11.89,2.17,15.08c0,0-6.2-11.93-23.87-14.64-8.98-1.39-20.16,14.55-20.16,14.55-3.94-1.26,1.65-21.29,1.65-21.29-12.52-94.47-3.31-77.37-5.79-123.55-1.65-29.64-10.01-156.43-.15-166.74l82.81,2.99Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-24"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m123.24,405.54c44.23,3.47,82.52-11,99.14-18.56-3.16-7.08-5.09-11.08-5.09-11.08l-6.62-14.01-82.7-3.01c-3.51,3.72-4.75,22.63-4.73,46.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m182.73,443.78c20.13,53.51,33.08,76.93,35.16,82.38,1.21,3.18,4.17,46.46,6.48,82.78,2.65-33.08,5.38-67.93,5.61-74.76.5-13.63-9.34-32.3-10.82-37.13-1.47-4.83,1.85-10.06,1.85-10.06l-17.7-22.33c.6-7.58-8.78-40.64-8.78-40.64-5.57,5.28-10.54,16.51-11.81,19.75Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m210.65,361.88l6.62,14.03s27.36,56.53,44.11,121.27c.4,1.54,9.06,32.2,2.12,108.57l3.97,13.4-4.33,22.13s6.52,9.41,6.29,12.49c0,0-16.08,2.99-21.5,5.87-4.17,2.25-16.69,14.6-16.69,14.6-3.56-.73-3.87-15.08-3.87-15.08,0,0-7.43-127.47-9.56-132.96-2.13-5.49-15.17-29.18-35.51-83.38,0,0-.46,75.7-5.89,94.85-4.85,17.04.89,64.72.89,64.72l-3.31,53.08s11.45,11.89,2.17,15.08c0,0-6.2-11.93-23.87-14.64-8.98-1.39-20.16,14.55-20.16,14.55-3.94-1.26,1.65-21.29,1.65-21.29-12.52-94.47-3.31-77.37-5.79-123.55-1.65-29.64-10.01-156.43-.15-166.74l82.81,2.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m182.35,442.8s10.11-19.5,18.72-24.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m204.88,411.54s-30.7,9.34-41.35,11.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m189.17,380.22c1.32,25.55,10.34,29.9,1.65,35.48,0,0,.25,11.96-4.09,19.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m135.38,370.44s3.62,39.28-8.47,46.67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m126.91,383.11s-.91,26.15,0,47.22c0,0,3.03,89.07,6.05,100.25,3.03,11.18-4.66,28.12-4,76.45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m155.89,644.85c-2.86-.62-5.85-.22-8.45,1.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m174.08,655.45c-3.79-3.69-8.19-6.71-13-8.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m169.12,448.97c-6.78,7.61-17.53,21.95-28.55,23.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m179.49,436.6c-2.08,2.63-4.23,5.21-6.42,7.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m169.83,525.62s-15.41,20.99-23.87,22.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m187.96,439.02s27.46,76.46,37,84c0,0,1.08,56.23,1.39,75.87.31,19.63,4.83,45.73,4.83,45.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m260.49,644.06s-10.57,3.66-15.71,5.99c-3.16,1.54-5.63,4.2-6.95,7.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m233.74,495.45c-14.74-9.25-34.17-20.81-42.01-37.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m246.59,503.07c-2.8-1.54-5.54-3.14-8.27-4.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m200.15,390.56c-7.92-.12-16.54-1.16-23.37-5.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m212.74,389.81c-2.27.31-4.55.51-6.83.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m227.44,214.23c-6.05-9.16-36.9-11.49-56.7-11.49s-43.83-3.31-54.68,19.02c-8.27,17.05,10.78,107.23,10.78,107.23l-4.66,38.93c35.86,11.25,97.29,8.77,97.29,8.77l-8.27-35.2s22.3-118.11,16.24-127.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m158.98,180.09s2.66,21.22-5.41,25.8c0,0,4.04,15.56,18.19,16.54,14.16.98,20.41-14.22,20.41-14.22l-33.19-28.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m234.01,125.61l36.23-3.34c1.71-.16,3.22,1.1,3.38,2.81h0l2.39,25.86h0l-42.36,3.91h0l-2.39-25.86c-.16-1.68,1.06-3.18,2.74-3.38Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-25"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m234.01,125.61l36.23-3.34c1.71-.16,3.22,1.1,3.38,2.81h0l2.39,25.86h0l-42.36,3.91h0l-2.39-25.86c-.16-1.68,1.06-3.18,2.74-3.38Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 261.81,
    y: 125.32,
    width: 10.47,
    height: 20.94,
    transform: "translate(-11.34 25.1) rotate(-5.27)"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m234.01,125.61l36.23-3.34c1.71-.16,3.22,1.1,3.38,2.81h0l2.39,25.86h0l-42.36,3.91h0l-2.39-25.86c-.16-1.68,1.06-3.18,2.74-3.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m296.66,119.79l36.23-3.34c1.71-.16,3.22,1.1,3.38,2.81h0l2.39,25.86h0l-42.43,3.91h0l-2.39-25.86c-.16-1.71,1.1-3.22,2.81-3.38h0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-33"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m296.66,119.79l36.23-3.34c1.71-.16,3.22,1.1,3.38,2.81h0l2.39,25.86h0l-42.43,3.91h0l-2.39-25.86c-.16-1.71,1.1-3.22,2.81-3.38h0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 327.86,
    y: 119.43,
    width: 6.32,
    height: 20.94,
    transform: "translate(-10.53 30.95) rotate(-5.27)"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m296.66,119.79l36.23-3.34c1.71-.16,3.22,1.1,3.38,2.81h0l2.39,25.86h0l-42.43,3.91h0l-2.39-25.86c-.16-1.71,1.1-3.22,2.81-3.38h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m283.5,121l36.23-3.34c1.71-.16,3.22,1.1,3.38,2.81h0l2.39,25.86h0l-42.49,3.92h0l-2.39-25.86c-.16-1.71,1.1-3.22,2.81-3.38.02,0,.04,0,.07,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m346.08,115.22l36.23-3.34c1.71-.16,3.22,1.1,3.38,2.81h0l2.39,25.86h0l-42.43,3.91h0l-2.39-25.86c-.16-1.71,1.1-3.22,2.81-3.38h0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 311.24,
    y: 120.76,
    width: 10.47,
    height: 20.94,
    transform: "translate(-10.72 29.62) rotate(-5.27)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 373.13,
    y: 115.04,
    width: 10.47,
    height: 20.94,
    transform: "translate(-9.93 35.28) rotate(-5.27)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m405.98,132.82l10.98,118.89-191.61,17.7-10.92-118.92c-.38-4.14,2.66-7.8,6.8-8.19l176.58-16.29c4.13-.38,7.79,2.66,8.17,6.79,0,0,0,.02,0,.03Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-30"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m405.98,132.82l10.98,118.89-191.61,17.7-10.92-118.92c-.38-4.14,2.66-7.8,6.8-8.19l176.58-16.29c4.13-.38,7.79,2.66,8.17,6.79,0,0,0,.02,0,.03Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m405.98,132.82l10.98,118.89-191.61,17.7-10.92-118.92c-.38-4.14,2.66-7.8,6.8-8.19l176.58-16.29c4.13-.38,7.79,2.66,8.17,6.79,0,0,0,.02,0,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m405.98,132.82l10.98,118.89-142.24,13.12-10.97-118.89c-.38-4.14,2.66-7.8,6.8-8.19l127.17-11.74c4.13-.43,7.82,2.57,8.24,6.7,0,.04,0,.08.01.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m396.77,137.93l-121.52,11.21c-1.68.12-3.15-1.13-3.31-2.81h0c-.12-1.68,1.12-3.15,2.8-3.31l121.52-11.21c1.68-.12,3.15,1.13,3.31,2.81h0c.11,1.67-1.13,3.13-2.8,3.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m183.25,138.01s-28.03-5.62-31.18,12.42c-3.14,18.04,7.13,25.72,7.13,25.72l24.05-38.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m159.2,186.06c-3.2-8.97-3.7-18.68-1.44-27.94,2.75-11.58,16.54-27.51,37.46-13.03,10.77,7.46,11.43,23.65,8.07,38.47-.79,3.54-.2,7-1.37,10.25-4.13,11.41-11.69,20.19-15.83,20.39-6.9.35-20.69-8.01-20.13-15.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m187.13,180.82s-5.57-4.04-10.93-.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m197.65,180.09s4.22-3.87,6.96-3.31"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m179.26,187c0,1.03.51,1.87,1.16,1.87s1.17-.84,1.17-1.87-.53-1.85-1.17-1.85-1.16.83-1.16,1.85Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-36",
    cx: 197.65,
    cy: 185.98,
    rx: 1.17,
    ry: 1.85
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m195.29,183.99c-2.05,2.68.83,12.88,0,13.61s-6.09-1.34-6.09-1.34c0,0-1.22-1.55,1.34-2.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m190.62,202.73s-7.06,0-8.95-2.58"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m173.72,164.51l-.55,8.53s-6.05,3.13-7.58,6.3c-.91,2.08-1.24,4.36-.96,6.62,0,0-3.67-6.42-5.66-5.89-.71.18-.71,2.88-.71,2.88,0,0-8.27-18.46-.79-28.22,7.48-9.76,16.24,9.77,16.24,9.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m162.06,184.13s-1.65-6.2-7.23-7.84-1.75,13.23,2.99,15.17c4.75,1.94,5.94,3.31,6.22,1.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m154.47,163.43c-.46-.63-2.51-16.54,7.99-23.68s28.25-6.38,39.55,3.51c11.3,9.89,8.09,27.04,0,32.9v-7.16s-3.72,7.18-14.89,7.77l3.41-5.26s-5.49,3.31-15.17,3.03c0,0,4.55-3.62,3.89-6.85.02,0-15.35,8.65-24.78-4.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m156.43,220.79c-7.74.93-18.76,11.03-11.58,28.98,4.58,11.38,42.23,4.61,42.23,4.61,13.96-5.76,34.35-26.46,49.32-36.07,0,0-3.16-19.85-6.8-17.04-16.92,12.95-30.83,13.84-54.43,25.19.05-.07-13.88-6.25-18.74-5.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m173.72,242.82c-.23,7.41,2.81,8.72,7.94,10.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m228.48,202.73c.35-1.08,6.62-12.09,8.39-14.89,1.77-2.8,9.68-5.33,12.74-7.01,3.06-1.69,3.31-4.25,4.96-2.41,1.65,1.84,0,6.02-9.16,10.47,3.26.18,6.52.18,9.77,0,2.45-.36,4.63-2.58,5.72-1.04s1.31,4.3-4.15,5.99c-2.6.94-5.31,1.5-8.07,1.65,2.67.57,5.3,1.33,7.86,2.28.88.65,2.18,2.15,3.49,2.38,1.31.23,2.73,1.65.33,3.31-1.73.95-3.81.99-5.57.1,0,0,6.33,3.06,4.37,4.96-1.97,1.9-8.27,1.52-8.27,1.52,0,0-9.34,11.4-17.25,9.01"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m239.68,187.83c1.09.25,1.95,1.1,2.22,2.18.55,1.95,2.15,2.07,3.13,4.25s.69,5.56,1.65,6.72,0,6.04,0,6.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m158.06,219.39c-4.05-5.16-13.15-2.83-13.15-2.83"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m139.94,207.05s9.36,1.37,12.12,9.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m156.43,256.37s-9.13,7.06-23.02-3.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m144.91,258.5s-4.63,6.4-15.91,6.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m202.93,339.03s-23.88,19.04-48.15,16.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m138.37,297.21s37.07,27.19,64.5,28.93"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-456"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m139.35,498.49c6.38-3.54,13.87-4.47,20.92-2.61,12.09,3.04,43.5,47.96,47.87,52.35,4.37,4.38,12.54,6.62,20.06,14.54,11.91,12.42,29.23,23.4,30.98,23.4s3.16-1.09,5.34-1.52,19.09-1.97,19.09-1.97c0,0,5.67,1.26,0,3.69-5.67,2.43-5.24,4.6-5.24,4.6,0,0-1.14,1.84,1.14,3.59,2.28,1.75,3.62.79,6.88,5.41s-4.6,2-4.6,2c0,0,1.74,4.96-1.75,4.47s-.43,4.85-6.1,4.12-17.81-8.39-20.86-16.41c0,0-49.52-23.67-56.93-29.77-7.41-6.1-38.6-38.83-40.74-39.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m268.9,542.82h36.39c1.72,0,3.11,1.39,3.11,3.11h0v25.97h-42.61v-25.97c0-1.72,1.39-3.11,3.11-3.11h0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-35"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m268.9,542.82h36.39c1.72,0,3.11,1.39,3.11,3.11h0v25.97h-42.61v-25.97c0-1.72,1.39-3.11,3.11-3.11h0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 295.57,
    y: 545.56,
    width: 10.47,
    height: 20.94
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m268.9,542.82h36.39c1.72,0,3.11,1.39,3.11,3.11h0v25.97h-42.61v-25.97c0-1.72,1.39-3.11,3.11-3.11h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m331.75,542.82h36.39c1.72,0,3.11,1.39,3.11,3.11h0v25.97h-42.61v-25.97c0-1.72,1.39-3.11,3.11-3.11h0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m331.75,542.82h36.39c1.72,0,3.11,1.39,3.11,3.11h0v25.97h-42.61v-25.97c0-1.72,1.39-3.11,3.11-3.11h0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 361.87,
    y: 545.56,
    width: 6.32,
    height: 20.94
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m331.75,542.82h36.39c1.72,0,3.11,1.39,3.11,3.11h0v25.97h-42.61v-25.97c0-1.72,1.39-3.11,3.11-3.11h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m318.52,542.82h36.39c1.72,0,3.11,1.39,3.11,3.11h0v25.97h-42.61v-25.97c0-1.72,1.39-3.11,3.11-3.11h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m381.37,542.82h36.39c1.72,0,3.11,1.39,3.11,3.11h0v25.97h-42.61v-25.97c0-1.72,1.39-3.11,3.11-3.11Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 345.18,
    y: 545.56,
    width: 10.47,
    height: 20.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 407.34,
    y: 545.56,
    width: 10.47,
    height: 20.94
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m439.41,565.84v119.4h-192.37v-119.4c0-4.16,3.37-7.53,7.53-7.53h177.32c4.16,0,7.53,3.37,7.53,7.53h0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-29"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m439.41,565.84v119.4h-192.37v-119.4c0-4.16,3.37-7.53,7.53-7.53h177.32c4.16,0,7.53,3.37,7.53,7.53h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m439.41,565.84v119.4h-192.37v-119.4c0-4.16,3.37-7.53,7.53-7.53h177.32c4.16,0,7.53,3.37,7.53,7.53h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m439.41,565.84v119.4h-142.75v-119.4c0-4.16,3.37-7.53,7.53-7.53h127.7c4.16,0,7.53,3.37,7.53,7.53h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m429.75,570.09h-122.03c-1.72,0-3.11-1.39-3.11-3.11h0c-.04-1.72,1.33-3.14,3.04-3.17.02,0,.04,0,.07,0h122.03c1.72,0,3.11,1.39,3.11,3.11h0c.04,1.72-1.33,3.14-3.04,3.17-.02,0-.04,0-.07,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m203.85,685.24c-9.92,0-23.87-6.38-39.93-13.13-16.66-7.01-35.63-14.42-54.88-15.53-7.18-.41-2.83,28.66-2.83,28.66h-15.71s-15.51-20.71-17.32-39.25c0,0,12.67-7.82,15.71-8.27,1.05-.11,2.1-.16,3.16-.15,3.41,0,7.96.15,7.96.15h0c-.73-.43-12.32-7.41-18.72-14.51-5.28-5.86-7.69-15.1-7.87-20.62.2-3.66.61-7.3,1.21-10.92l82.57,1.37s.89.63,2.48,1.8c9.58,6.98,44.57,32.98,62.07,52.58,5.66,6.33,9.48,11.99,10.04,16.13,2.63,19.07-12.97,21.68-27.94,21.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m221.77,647.4l-40.16,9.18c-6.89,3.94-12.91,9.22-17.71,15.53-16.66-7.01-35.63-14.42-54.88-15.53-7.18-.41-2.83,28.66-2.83,28.66h-15.71s-15.48-20.71-17.28-39.25c0,0,14.62,20.84,18.19,31.43,0,0,5.67-19.58,14.89-27.44-4.16-4.69-8.89-8.84-14.08-12.36,3.41,0,7.96.15,7.96.15h0c-.73-.43-12.32-7.41-18.72-14.51-5.28-5.86-7.41-15.12-7.87-20.62-.23-2.71.1-10.92.1-10.92,0,0,61.58,8.78,86.15,3.18,9.46,6.95,44.46,32.9,61.96,52.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m157.21,645.99s32.72,16.39,41.45,22.81c8.73,6.42,11.33,4.68,11.33,4.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m81.31,644.26s7.86,11.99,8.27,15.58"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m212.9,414.09s17.42-7.58,15.76,24.64c-1.65,32.22,4.25,33.87,4.25,33.87,0,0-43.83,18-54.96,2.61-11.13-15.38-.56-57.47,34.95-61.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m210.47,472.61s-18.03,8.5-19.67,16.36c-1.64,7.86-24.21-3.97-24.21-3.97l16.36-23.52,27.52,11.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m92.26,558.85c-41.35,52.66-7.79,78.07,39.08,73.87l-9.39,14.89,23.59,4.09s18.08-11.81,42.72-24.43c41.94-21.5,58.9-20.21,54.58-41.73-4.32-21.52-55.72-35.48-107.26-12.8-.05-.02-28.03-33.26-43.32-13.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m106.68,673.48s10.77-29.77,15.27-31.43c4.5-1.65,21.5,4.8,23.59,9.59,0,0,5.74-8.8,8.09-5.06,2.35,3.74-1.04,9.92,0,14.65,1.04,4.73,12.67,11.35,17.32,12.22s7.29,3.49,7.29,6.1v5.67h-71.55c-1.6-3.76-1.6-8,0-11.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m153.62,656.58s-9.48,4.68-12.93,3.31c-3.46-1.37,1.77,7.86,3.08,8.73s9.92-3.06,9.92-3.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m115.63,651.67s12.87.25,16.79,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m106.68,673.48s20.51,4.8,22.25,4.8c2.82-.56,5.59-1.36,8.27-2.4,0,0,5.62,2.83,9.36,4.58,3.74,1.75,28.12,0,28.12,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m131.34,632.74c19.58-2.12,57.62-26.25,70.86-34.63s16.54-6.19,16.54-6.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m73.54,591.64l3.13-23.73,7.54-5.69c12.22-29.66,67.6-85.05,82.7-84.86,22.68.26,26.68,24.07,29.47,50.11,2.8,26.05-32.53,22.13-32.53,22.13v6.53l-20.1,10.4,12.17-.38s-35.01,34.04-82.38,25.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m171.68,431.49c4.75-14.89,26.46-18.86,34.27-16.42,6.41,2.5,11.66,7.29,14.74,13.45,1.98,4.28-2.17,11.86.79,16.27,4.23,6.33,3.87,19.7,2.35,28.12-.83,4.47-19.4,7.11-34.58-3.31-16.31-11.28-22.16-23.78-17.56-38.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m193.63,410.62s19.12-3.11,19.25,1.8c.84,32.63-18.72,39.48-18.72,39.48,0,0-7.99-6.37-9.77-2s2.81,16.44,8.47,16.69c-2.66,4.13-2.75,9.41-.23,13.63,0,0-32.38,5.41-35.06-9.59,1.25-5.21,2.15-10.51,2.68-15.84,2.1-21.02-2.81-35.16,33.39-44.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m219.17,443.88c3.99,3.59,6.85,3.59,6.8,4.88-.15,4.02-4.96,6.02-4.96,6.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m220.91,461.48c-2.82.95-5.86,1.03-8.72.22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m210.3,423.85s12.72-3.69,10.39,16.95c0,0,5.29-7.19,5.28-15.28,0-14.01-18.74-11.2-18.74-11.2l2.45,9.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m221.87,433.96c-.97-.65-2.17-.87-3.31-.61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m213.3,433.72s-6.83.4-9.79,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m211.66,444.59c.1,1.09-.36,2.03-1.04,2.1s-1.31-.78-1.42-1.87.36-2.03,1.04-2.1,1.32.78,1.42,1.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m132.42,637.71s15.22,1.65,18.52,8.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m170.94,488.52c6.38-3.54,13.87-4.47,20.92-2.61,12.11,3.06,43.5,47.96,47.87,52.35s12.54,6.62,20.06,14.54c11.91,12.42,29.23,23.4,30.98,23.4s3.16-1.09,5.34-1.52,19.09-1.97,19.09-1.97c0,0,5.67,1.27,0,3.69-5.67,2.41-5.24,4.61-5.24,4.61,0,0-1.12,1.82,1.14,3.57,2.27,1.75,3.62.79,6.88,5.41,3.26,4.61-4.6,2-4.6,2,0,0,1.74,4.96-1.75,4.47s-.43,4.85-6.1,4.12c-5.67-.73-17.81-8.39-20.86-16.41,0,0-49.52-23.67-56.93-29.77-7.41-6.1-38.57-38.83-40.77-39.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m163.83,483.72s24.41-6.53,32.93-1.74c8.52,4.8,24.66,27.04,24.66,27.04,0,0-19.68,17.61-25.77,16.01-6.09-1.6-24.71-4.23-24.71-4.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m185,522.95s-8.85,4.86-12.11,4.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m170.94,498.56c.74,1.31.5,15.61,16.03,20.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m87.93,562.68s33.08,5.67,44.49-4.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m143.73,566.54s-8.27-1.46-11.31,2.8c-3.04,4.25-19.62,8.27-19.62,8.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m77.24,598.11s-4.78,20.61,15.61,29.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m87.93,599.53s.12,10.16,3.31,15.71l10.14,3.31,11.35-6.32s-2.41-12.98-2.63-15.61"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPessoasMontandoLego);
export default __webpack_public_path__ + "static/media/PessoasMontandoLego.6e04be0101007ff4f4452e636237353e.svg";
export { ForwardRef as ReactComponent };